export default __webpack_public_path__ + "static/hero-mobile-image-4a87f8a9fd2541c420a88366708598bd.jpg";